<template>

    <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="() => {}">
            <div class="p-5">
                <div
                    class="
                        d-flex
                        justify-content-between
                        align-items-center
                        mb-5
                    "
                >
                    <div class="c-title">Account Details</div>
                    <button class="ml-auto btn c-btn-secondary" @click="isShowModalChangePassword = true">
                        Change Password
                    </button>
                    <button type="submit" class="btn ml-3 c-btn-primary" @click="handleSubmit(onSubmit)">
                        Save
                    </button>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-12">
                        <div>
                            <TextField
                                v-model="form.account_name"
                                name="account_name"
                                label="Account Name"
                                rules="required"
                                class-wrapper="input"
                                :readonly="isApproved"
                                v-if="isOwner"
                            />
                            <TextField
                                v-model="form.first_name"
                                name="first_name"
                                :label="isOwner ? 'Contact First Name' : 'First Name'"
                                rules="required"
                                class-wrapper="input"
                            />
                            <TextField
                                v-model="form.last_name"
                                name="last_name"
                                :label="isOwner ? 'Contact Last Name' : 'Last Name'"
                                rules="required"
                                class-wrapper="input"
                            />
                            <TextareaField
                                v-model="form.purpose"
                                name="purpose"
                                label="Account Purpose"
                                rules="required"
                                rows="5"
                                classWrapper="mb-4 input"
                                :readonly="isApproved"
                                v-if="isOwner"
                            />
                            <TextField
                                v-model="form.permission_level_name"
                                name="permission_level"
                                label="Permission Level"
                                rules="required"
                                class-wrapper="input"
                                v-if="!isOwner"
                                readonly
                            />
                            <div class="d-flex align-items-start w-65">
                                <TextField
                                    v-model="form.email"
                                    name="email"
                                    label="Email"
                                    rules="required"
                                    readonly
                                    class-wrapper="input flex-grow-1"
                                />
                                <button class="ml-3 mt-2 btn btn-sm c-btn-primary" @click="isShowModalChangeEmail = true">
                                    Change
                                </button>
                            </div>
                            <div class="d-flex align-items-start">
                                <TextField
                                    v-model="form.phone_num"
                                    name="phone_num"
                                    label="Phone"
                                    rules="required"
                                    readonly
                                    class-wrapper="input flex-grow-1"
                                />
                                <button class="ml-3 mt-2 btn btn-sm c-btn-primary"  @click="isShowModalChangePhone = true">
                                    Change
                                </button>
                            </div>
                            <TextField
                                v-model="form.address1"
                                name="address1"
                                label="Address"
                                rules="required"
                                class-wrapper="input"
                                v-if="isOwner"
                            />
                            <TextField
                                v-model="form.address2"
                                name="address2"
                                label="Address 2"
                                class-wrapper="input"
                                v-if="isOwner"
                            />
                            <TextField
                                v-model="form.city"
                                name="city"
                                label="City"
                                rules="required"
                                class-wrapper="input"
                                v-if="isOwner"
                            />
                            <div class="row input no-gutters" v-if="isOwner">
                                <div class="col-7">
                                    <SelectField
                                        v-if="states.length"
                                        v-model="form.state"
                                        name="form.state"
                                        label="State"
                                        :options="stateOptions"
                                        :disabled="isDisabledStateOptions"
                                        :has-icon="true"
                                    >
                                        <template #append-icon>
                                            <a @click.prevent="() => {}">
                                                <i
                                                    class="fa fa-chevron-circle-down mt-2"
                                                    style="font-size: 20px; color: #40b8dc"
                                                />
                                            </a>
                                        </template>
                                    </SelectField>
                                </div>
                                <div class="col-5 pl-4">
                                    <TextField
                                        v-model="form.zip"
                                        name="form.zip"
                                        label="Zip"
                                        rules="required"
                                    />
                                </div>
                            </div>
                            <SelectField
                                v-if="isOwner && countries.length"
                                v-model="form.country"
                                name="form.country"
                                label="Country"
                                :options="countries"
                                rules="required"
                                :has-icon="true"
                                class-wrapper="input"
                            >
                                <template #append-icon>
                                    <a @click.prevent="() => {}">
                                        <i
                                            class="fa fa-chevron-circle-down mt-2"
                                            style="font-size: 20px; color: #40b8dc"
                                        />
                                    </a>
                                </template>
                            </SelectField>
                        </div>
                        <div v-if="isOwner">
                            <div class="c-title integration-title">Integrations</div>
                            <div class="mt-3">
                                <TextField
                                    v-model="form.hubspot_api_key"
                                    name="hubspot_api_key"
                                    label="HubSpot API Key"
                                    class-wrapper="input"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 pl-5" v-if="isOwner">
                        <h6 class="text-secondary">Fund Logo - Dark Mode (click to replace)</h6>
                        <input ref="inputFundLogo" style="display: none" type="file" value="" @change="changeFundLogoImage" accept="image/*" />
                        <div class="fund-logo mt-2 mb-2" @click="$refs.inputFundLogo.click()">
                            <img :src="form.fund_logo_dark" alt="" />
                        </div>

                        <h6 class="text-secondary mt-5">Fund Logo - Light Mode (click to replace)</h6>
                        <input ref="inputFundLogoLight" style="display: none" type="file" value="" @change="changeFundLogoLightImage" accept="image/*" />
                        <div class="fund-logo light mt-2 mb-2" @click="$refs.inputFundLogoLight.click()">
                            <img :src="form.fund_logo_light" alt="" />
                        </div>
                        <div class="mt-4">
                            <h6>The image should be:</h6>
                            <ul class="pl-4">
                                <li>Height of 86px</li>
                                <li>Width up to 430px</li>
                                <li>PNG on a transparent background</li>
                                <li>Should look good on the blue background above</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <ModalAccountChangePassword
            v-if="isShowModalChangePassword"
            @emit-verification="performPasswordChangeVerification"
            @close="isShowModalChangePassword = false" />

        <ModalAccountChangeEmail
            v-if="isShowModalChangeEmail"
            @emit-verification="performEmailChangeVerification"
            @close="isShowModalChangeEmail = false" />

        <ModalAccountChangePhone
            v-if="isShowModalChangePhone"
            @emit-verification="performPhoneChangeVerification"
            :user_country_code="form.country"
            @close="isShowModalChangePhone = false" />

        <ModalAccount2StepVerifyProgress
            v-if="isShowModal2StepVerificationProgress"
            :factor-type="changeFactorType"
            :data="twoFactorVerificationData"
            @close="isShowModal2StepVerificationProgress = null"
            @finish="finish2StepVerification"
        />
    </ValidationObserver>

</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import TextareaField from '@/commons/FormElements/TextareaField.vue';
import SelectField from '@/commons/FormElements/SelectField.vue';
import DibbleApi from '@/api';
import DibbleJs from '@/dibble';
import ModalAccountChangePassword from "@/components/account/sub-components/ModalAccountChangePassword.vue";
import ModalAccount2StepVerifyProgress from "@/components/account/sub-components/ModalAccount2StepVerifyProgress.vue";
import ModalAccountChangeEmail from "@/components/account/sub-components/ModalAccountChangeEmail.vue";
import ModalAccountChangePhone from "@/components/account/sub-components/ModalAccountChangePhone.vue";
import DibbleJS from "@/dibble";

export default {
    name: 'AccountView',
    components: {
        TextField,
        TextareaField,
        SelectField,
        ModalAccountChangePassword,
        ModalAccountChangeEmail,
        ModalAccountChangePhone,
        ModalAccount2StepVerifyProgress,
    },
    data() {
        return {
            accountData: {},
            country_code: 'US',
            form: {
                account_name: '',
                first_name: '',
                last_name: '',
                purpose: '',
                email: 'abc',
                phone_num: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
                country: 'US',
                fund_logo_dark: '',
                permission_level_name: '',
                hubspot_api_key: ''
            },
            previous_state: '',
            states: [],
            countries: [],
            stateOutsideUS: [
                {
                    value: '',
                    label: 'Outside of the US',
                },
            ],
            accountStatus: null,
            changeFactorType: '',
            twoFactorVerificationData: null,
            isShowModalChangePassword: false,
            isShowModalChangeEmail: false,
            isShowModalChangePhone: false,
            isShowModal2StepVerificationProgress: false,
        };
    },
    computed: {
        stateOptions() {
            return this.form.country === 'US'
                ? this.states
                : this.stateOutsideUS;
        },
        isDisabledStateOptions() {
            return this.form.country !== 'US';
        },
        isApproved() {
            return this.accountStatus && this.accountStatus === 3;
        },
        isOwner() {
            return this.$cookies.get('_user').is_owner;
        },
    },
    watch: {
        'form.country'(value) {
            if (value !== 'US') {
                this.previous_state = this.form.state;
                this.form.state = '';
            } else {
                if (this.previous_state)
                    this.form.state = this.previous_state;
                else
                    this.form.state = this.states[0].value;
            }
        }
    },
    methods: {
        onSubmit() {
            if (this.form.country === 'US' && !this.form.state) {
                DibbleJs.toastErrorMessage('Please select state');
                return;
            }

            DibbleJs.showLoader();
            const data = {
                '#request': this.isOwner ? DibbleApi.api.updateMyAccount : DibbleApi.api.managedUserUpdateMyAccount,
                account_name: this.form.account_name,
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                purpose: this.form.purpose,
                address1: this.form.address1,
                address2: this.form.address2,
                city: this.form.city,
                state: this.form.state,
                zip: this.form.zip,
                country: this.form.country,
                hubspot_api_key: this.form.hubspot_api_key,
                fund_logo_dark: this.form.fund_logo_dark,
                fund_logo_light: this.form.fund_logo_light,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage('Update account successfully');
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        getStates() {
            const params = {
                '#request': DibbleApi.api.getStateList,
            };
            DibbleJs.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const { states } = response;
                    if (states.length) {
                        this.states = states.map((item) => ({
                            value: item.state_code,
                            label: item.name,
                        }));
                    }
                }
            });
        },
        getCountries() {
            const params = {
                '#request': DibbleApi.api.getCountryList,
            };
            DibbleJs.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const { countries } = response;
                    if (countries.length) {
                        this.countries = countries.map((item) => ({
                            value: item.country_code,
                            label: item.name,
                        }));
                    }
                }
            });
        },
        getMyDetails() {
            DibbleJs.showLoader();
            const data = {
                '#request': this.isOwner ? DibbleApi.api.getMyDetails : DibbleApi.api.managedUserGetMyDetails
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.form = {
                        account_name: response.account_name,
                        first_name: response.first_name,
                        last_name: response.last_name,
                        purpose: response.purpose,
                        email: response.email,
                        phone_num: this.isOwner ? response.phone_num : response.phone,
                        address1: response.address1,
                        address2: response.address2,
                        city: response.city,
                        state: response.state,
                        zip: response.zip,
                        country: response.country,
                        hubspot_api_key: response.hubspot_api_key,
                        fund_logo_dark: response.fund_logo_dark,
                        fund_logo_light: response.fund_logo_light,
                        permission_level_name: response.permission_level_name || ''
                    };
                    this.accountData = response;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        getMyAccountStatus() {
            const params = {
                '#request': DibbleApi.api.getMyAccountStatus,
            };
            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.accountStatus = response.status;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
            });
        },
        performPasswordChangeVerification(data) {
            this.changeFactorType = 'Password';
            this.isShowModalChangePassword = false;
            this.twoFactorVerificationData = data;
            this.isShowModal2StepVerificationProgress = true;
        },
        performEmailChangeVerification(data) {
            this.changeFactorType = 'Email';
            this.isShowModalChangeEmail = false;
            this.twoFactorVerificationData = data;
            this.isShowModal2StepVerificationProgress = true;
        },
        performPhoneChangeVerification(data) {
            this.changeFactorType = 'Phone';
            this.isShowModalChangePhone = false;
            this.twoFactorVerificationData = data;
            this.isShowModal2StepVerificationProgress = true;
        },
        finish2StepVerification(relogin = false) {
            if (relogin) {
                DibbleJS.cookieDestroy();
                this.$router.push('/login');
            } else {
                this.isShowModal2StepVerificationProgress = false;
                this.twoFactorVerificationData = null;
                this.getMyDetails();
            }
        },
        changeFundLogoImage (input) {
            const files = input.target.files;
            if (files && files.length > 0) {
                for (let i = 0;i < files.length;i++) {
                    const reader = new FileReader();
                    const file = files[i];
                    if (file.type.indexOf('image') < 0) {
                        DibbleJS.toastErrorMessage("Invalid image type.");
                        return false;
                    }

                    const defineDimensions = {
                        width: 430,
                        height: 86,
                    };

                    reader.onload = (e) => {
                        console.log(e);

                        // Check define dimensions


                        const img = new Image();
                        img.src = e.target.result;

                        img.onload = () => {
                            const { width, height } = img;
                            if (height !== defineDimensions.height || width > defineDimensions.width) {
                                DibbleJS.toastErrorMessage(`Image should be up to ${defineDimensions.width}px width and ${defineDimensions.height}px height.`);
                                return false;
                            }

                            this.form.fund_logo_dark = e.target.result;
                        }
                    };

                    reader.readAsDataURL(files[i]);
                }
            }
            this.formDirty = true
        },
        changeFundLogoLightImage (input) {
            const files = input.target.files;
            if (files && files.length > 0) {
                for (let i = 0;i < files.length;i++) {
                    const reader = new FileReader();
                    const file = files[i];
                    if (file.type.indexOf('image') < 0) {
                        DibbleJS.toastErrorMessage("Invalid image type.");
                        return false;
                    }

                    const defineDimensions = {
                        width: 430,
                        height: 86,
                    };

                    reader.onload = (e) => {
                        console.log(e);

                        // Check define dimensions


                        const img = new Image();
                        img.src = e.target.result;

                        img.onload = () => {
                            const { width, height } = img;
                            if (height !== defineDimensions.height || width > defineDimensions.width) {
                                DibbleJS.toastErrorMessage(`Image should be up to ${defineDimensions.width}px width and ${defineDimensions.height}px height.`);
                                return false;
                            }

                            this.form.fund_logo_light = e.target.result;
                        }
                    };

                    reader.readAsDataURL(files[i]);
                }
            }
            this.formDirty = true
        },
    },
    created() {
        const userAuth = this.$cookies.get("_user");
        if (this.isOwner) {
            this.getStates();
            this.getCountries();
            this.getMyDetails();
            this.getMyAccountStatus();
        } else {
            this.getMyDetails();
        }


        if (userAuth.need_change_password) {
            DibbleJS.toastErrorMessage('You need to change your password first.')
            this.isShowModalChangePassword = true
        }
    },
};
</script>

<style lang="scss" scoped>
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}
.input {
    max-width: 520px;
}
.fund-logo {
    padding: 32px;
    background: #00073B;
    border-radius: 20px;
    width: fit-content;
    cursor: pointer;

  &.light {
    background: #fff;
  }
}
.integration-title {
    padding-bottom: 10px;
    border-bottom: 2px solid #2178ab;
}
</style>
